import { Link } from 'react-router-dom'
import Card from 'app/frontend/base/components/Card'
import Section from 'app/frontend/base/components/Section'
import BannerImage from 'app/frontend/base/components/BannerImage'
import { usePageInfo } from 'app/frontend/base/config/queries'
import { useVisibleTeamsForUser } from 'app/frontend/base/hooks/useVisibleTeamsForUser'
import RaidPlansOverviewContent from 'app/frontend/base/pages/TeamDashboard/subpages/TeamPlans/components/RaidPlansOverviewContent'
import TeamPlansIntro from 'app/frontend/base/pages/TeamDashboard/subpages/TeamPlans/components/TeamPlansIntro'

const UserPlans = () => {
  const {
    data: { user },
  } = usePageInfo()
  const teams = useVisibleTeamsForUser(user)

  return (
    <Section title='Plans'>
      <RaidPlansOverviewContent
        owner={{ ownerType: 'user' }}
        basePath='/profile/plans'
        canEdit={true}
        intro={<TeamPlansIntro />}
        beforePlans={({ teamPlanCounts, isLoading }) => (
          <>
            <h5>Team plans</h5>
            <div className='grid gap-4 md:grid-cols-2 xl:grid-cols-3'>
              {teams.map((team) => (
                <Link to={`${team.path}/events/plans`} key={team.id}>
                  <Card className='p-4 hover:border-primary transition-colors'>
                    <div className='flex items-center gap-3'>
                      <BannerImage
                        faction={team.ownerReference?.faction}
                        fileName={team.ownerReference?.bannerFilename}
                        size='small'
                      />
                      <div className='min-w-0'>
                        <div className='font-medium truncate'>
                          {team.ownerReference.name} - {team.name}
                        </div>
                        <div
                          className={`text-sm text-muted-foreground transition-opacity duration-300 ${
                            isLoading ? 'opacity-0' : 'opacity-100'
                          }`}
                        >
                          {teamPlanCounts[team.id] ?? 0} plans
                        </div>
                      </div>
                    </div>
                  </Card>
                </Link>
              ))}
            </div>

            <h5>Personal plans</h5>
          </>
        )}
      />
    </Section>
  )
}

export default UserPlans
